import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FieldArrayType, FormlyFieldConfig } from '@ngx-formly/core';
import { FirstDataRenderedEvent, GridOptions, ColDef } from 'ag-grid-community';
import { GridFormlyCellComponent } from './grid-formly-cell.component';
import { RemoveButtonRendererComponent } from './remove-button-rendered.component';
import { FormArray, FormControl, Validators } from '@angular/forms';
import { FormlyApiService } from 'src/app/service/formly-api.service';
import { AgGridModule } from 'ag-grid-angular';
import { TranslateModule } from '@ngx-translate/core';
import { format } from 'date-fns';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'formly-field-grid',
  template: `
    <div [ngStyle="style" *ngIf="hide" class="mt-3 wholeGrid">
      <div class="label-container">
        <mat-label>
          <span class="label">{{ to.label | translate }}</span>
        </mat-label>
        <div class="plus">
          <i
            class="fa fa-plus-circle icon"
            aria-hidden="true"
            (click)="addRow()"
            *ngIf="props['isAddRemoveEnabled']"
          ></i>
        </div>
      </div>
      <ag-grid-angular
        class="className grid"
        [gridOptions]="gridOptions"
        [rowData]="model"
        (firstDataRendered)="onFirstDataRendered($event)"
      >
      </ag-grid-angular>
    </div>
  `,
  styles: [
    `
      :host ::ng-deep .mdc-line-ripple::before,
      .mdc-line-ripple::after {
        bottom: 12px;
      }
      // :host ::ng-deep .mat-mdc-form-field-infix {
      //   padding: 0px;
      // }
      :host
        ::ng-deep
        .mdc-text-field--filled:not(.mdc-text-field--disabled)
        .mdc-line-ripple::after {
        bottom: 12px;
      }
      :host ::ng-deep .mat-mdc-form-field-type-checkbox .mdc-line-ripple {
        visibility: hidden;
      }
      .wholeGrid {
        margin-bottom: 5%;
      }
      .label {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.54);
        font-family: Roboto, Helvatica, sans-serif !important;
        flex-grow: 1;
      }
      .label-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
      }

      .plus {
        display: flex;
        align-items: center;
      }
      .required-icon {
        color: #ff5722;
      }
      .grid {
        width: 100%;
        height: 100%;
        margin-top: 10px;
        // padding-bottom:30px;
      }

      .icon {
        color: rgb(23 23 114);
        font-size: 27px;
      }

      // ::ng-deep .ag-header-cell{

      //  width:172px !important;
      // }
      // ::ng-deep .ag-header-cell[col-id="remove"] {
      //   /* Adjust the width as needed */
      //   width: 200px !important;
      // }
      ::ng-deep .ag-header-cell .ag-header-cell-text {
        margin: auto !important;
      }
      ::ng-deep .grid .mdc-checkbox {
        margin-left: 100% !important;
      }

      ::ng-deep .ag-body-vertical-scroll-viewport {
        overflow-y: clip !important;
      }
      ::ng-deep .ag-body-horizontal-scroll-viewport {
        overflow-x: clip !important;
      }
      ::ng-deep .ag-center-cols-viewport {
        overflow-x: hidden !important;
      }
      :host ::ng-deep .form-control:disabled {
        margin-top: 10px !important;
      }
      :host ::ng-deep .mdc-text-field__input {
      }
      :host ::ng-deep .mat-mdc-form-field-suffix {
        top: 0px !important;
      }
      :host ::ng-deep .mat-mdc-icon-button {
        top: -25px !important;
      }
      // :host ::ng-deep .ag-row:hover{
      //   background:white;
      // }
    `,
  ],
  standalone:true,
  imports:[
    AgGridModule,    GridTypeComponent, TranslateModule,
    GridFormlyCellComponent,MatFormFieldModule,CommonModule
  ]
})
export class GridTypeComponent extends FieldArrayType implements OnInit {
  gridOptions: any;
  style: any = {};

  hide: boolean = true;
  hideName: any;
  hideValue: any;
  controlArray: any;
  arrayControls: any;
  isHideButtons: boolean = false;
  fields: FormlyFieldConfig[] = [];
  constructor(
    private formlyApiService: FormlyApiService,
    private elRef: ElementRef,
    private renderer: Renderer2
  ) {
    super();
  }
  ngOnInit() {
    // console.log('grid', this.field);
    this.fields = this.formlyApiService.getdata();
    this.controlArray = this.field?.key;
    this.style = {
      width: this.props['width'],
      height: this.props['height'],
    };

    // map cell Renderer to Formly Component
    this.props['gridOptions'].columnDefs.forEach((column: ColDef) => {
      column.cellRenderer = GridFormlyCellComponent;
    });

    // set grid options and context of the parent formly field
    const gridOptions: GridOptions = this.props['gridOptions'] || {};
    gridOptions.context = {
      parentField: this.field,
    };

    this.gridOptions = gridOptions;
    if (this.props['isAddRemoveEnabled']) {
      this.gridOptions.columnDefs.push({
        headerName: 'Action',
        field: 'remove',
        cellRenderer: RemoveButtonRendererComponent, // use the alias here
        editable: false,
        maxWidth: 200, // adjust as needed
      });
    }

    this.gridOptions.context = {
      ...this.gridOptions.context, // preserve other context properties
      componentParent: this,
    };
    if (this.field?.props?.hasOwnProperty('arrayHide')) {
      (this.form.get(this.controlArray) as FormArray).controls.forEach(
        (activityGroup: any) => {
          // Iterate over controls in the FormGroup and clear validators
          Object.keys(activityGroup.controls).forEach((controlName) => {
            const control = activityGroup.get(controlName);
            if (control.errors?.required) {
              control.isValidation = true;
              control.clearValidators();
              control.updateValueAndValidity(); // Update the value and trigger re-validation
            }
          });
        }
      );
      // console.log(this.form);
      this.hide = false;
      let data = this.field?.props?.arrayHide;
      let regex = /model\.(\w+)\s*!==\s*'([^']+)'/;
      let matches = regex.exec(data);
      if (matches && matches.length === 3) {
        this.hideName = matches[1];
        this.hideValue = matches[2];

        const findData: any = this.fields[0].fieldGroup?.find(
          (a: any) => a['key'] == this.hideName
        );
        const currentArrayFieldData: any = findData?.key;
        const currentArrayFieldControl = this.form.get(
          currentArrayFieldData
        ) as FormControl;

        if (currentArrayFieldControl) {
          if (currentArrayFieldControl.value) {
            this.valueChages(currentArrayFieldControl.value);
          }
          currentArrayFieldControl.valueChanges.subscribe(
            (selectedValue: any) => {
              this.valueChages(selectedValue);
            }
          );
        }
      }
    }
  }

  onFirstDataRendered(params: FirstDataRenderedEvent) {
    params.api.sizeColumnsToFit();
  }

  addRow() {
    // Create a new empty row and push it to your model
    const newRow = {
      investmentName: 'project1',
      investmentDate: '',
      stockIdentifier: 10,
    };

    // Ensure that the newRow object contains properties corresponding to your column definitions
    //  let model=[]
    this.add(this.model.length, newRow);
    // Refresh the grid data
    if (this.gridOptions != null) {
      //       let a =this.field.templateOptions.height;
      // let numericValue = parseInt(a); // Parse the string to an integer
      this.field.props.height = '10px';
      // console.log(this.field.templateOptions.height)
      this.gridOptions.api.setRowData(this.model);
    }
  }

  removeRow(params: any) {
    const rowData = params.rowData;
    // Find the index of the row and use splice() to remove it
    const index = this.model.findIndex((row: any) => row === rowData);
    if (index >= 0) {
      this.remove(index);
    }
    // Refresh the ag-Grid table view to reflect the changes
    if (this.gridOptions.api) {
      this.gridOptions.api.setRowData(this.model);
    }
  }
  valueChages(selectedValue: any) {
    let value = selectedValue?.toString();
    if (value === this.hideValue) {
      this.hide = true;
      // this.arrayControls.push(new FormControl());
      (this.form.get(this.controlArray) as FormArray).controls.forEach(
        (activityGroup: any) => {
          // Iterate over controls in the FormGroup and clear validators
          Object.keys(activityGroup.controls).forEach((controlName) => {
            const control = activityGroup.get(controlName);
            if (control) {
              if (control.isValidation) {
                control.isValidation = false;
                control.addValidators(Validators.required);
                control.updateValueAndValidity(); // Update the value and trigger re-validation
              }
            }
          });
        }
      );
      // }
    } else {
      this.hide = false;
      (this.form.get(this.controlArray) as FormArray).controls.forEach(
        (activityGroup: any) => {
          // Iterate over controls in the FormGroup and clear validators
          Object.keys(activityGroup.controls).forEach((controlName) => {
            const control = activityGroup.get(controlName);
            if (control) {
              if (!control.isValidation) {
                control.isValidation = true;
                control.setValue(null);
                control.clearValidators();
                control.updateValueAndValidity(); // Update the value and trigger re-validation
              }
            }
          });
        }
      );
    }
  }
  ngAfterViewChecked() {
    const timeInputs = this.elRef.nativeElement.querySelectorAll(
      'input[type="time"].mdc-text-field__input'
    );

    if (timeInputs) {
      timeInputs.forEach((timeInput) => {
        this.renderer.removeClass(timeInput, 'mdc-text-field__input');
      });
    }
  }
}
